import React from 'react';

interface ConfigStatusProps {
    loading: boolean;
    error: string | null;
}

const ConfigStatus: React.FC<ConfigStatusProps> = ({ loading, error }) => {
    if (loading) {
        return (
            <span className='my-12 flex items-center justify-center text-3xl font-bold'>
                Loading configuration...
            </span>
        );
    }

    return (
        <span className='my-12 flex items-center justify-center text-3xl font-bold text-red-600'>
            Failed to load configuration: {error || 'Unknown error'}
        </span>
    );
};

export default ConfigStatus;
